import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";

export default function Login() {
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back");
      navigate("/account");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="bg-poche-black text-white min-h-[80vh] grid grid-cols-1 md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="/lifestyle/lifestyle_story.png" className="w-full h-full object-cover" alt="" />
        <div className="absolute inset-0 bg-gradient-to-tr from-black/85 to-transparent" />
        <div className="absolute bottom-10 left-10 max-w-xs">
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Joseph Poche</p>
          <h2 className="font-serif text-4xl text-white mt-3">Welcome to the house.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center px-8 md:px-16 py-16">
        <div className="w-full max-w-md">
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Sign In</p>
          <h1 className="font-serif text-5xl mt-3">Enter the atelier.</h1>
          <form onSubmit={submit} className="mt-10 space-y-5">
            <Field label="Email" testid="login-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
            <Field label="Password" testid="login-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
            <button type="submit" data-testid="login-submit" disabled={busy} className="btn-gold w-full justify-center disabled:opacity-60">
              {busy ? "Signing in…" : "Sign In"}
            </button>
          </form>
          <div className="flex items-center my-7 gap-4 text-[10px] tracking-luxury uppercase text-white/35">
            <div className="flex-1 h-px bg-white/15" />
            <span>Or</span>
            <div className="flex-1 h-px bg-white/15" />
          </div>
          <button data-testid="login-google" onClick={loginWithGoogle} className="btn-outline-gold w-full justify-center">
            Continue with Google
          </button>
          <p className="text-center mt-8 text-sm text-white/55">
            New to POCHE? <Link to="/register" className="text-poche-gold underline underline-offset-4">Create an account</Link>
          </p>
          <p className="text-center text-[10px] tracking-luxury uppercase text-white/35 mt-10">
            Demo: demo@poche.com / Demo2026!
          </p>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", required, testid }) {
  return (
    <div>
      <label className="text-[10px] tracking-luxury uppercase text-white/55">{label}</label>
      <input data-testid={testid} type={type} value={value} onChange={onChange} required={required} className="w-full bg-transparent border-b border-white/25 focus:border-poche-gold py-3 text-white focus:outline-none" />
    </div>
  );
}
